<template lang="pug">
    v-dialog(v-model='dialog' scrollable persistent max-width='600px')
        template(v-slot:activator='{ on }')
            v-btn(icon :light="!dark" :dark="dark" v-on='on')
                v-icon mdi-trash-can-outline
        v-card
            v-card-title
                span.text-h5 Remove Vehicle
            v-card-text
                v-container
                    span.text-h6 Are you sure you want to delete this vehicle?

                v-container
                    span {{ vehicleYearMakeModel }}

            v-card-actions.text-right
                v-spacer
                    v-btn.ma-2(color="var(--volie-blue)" outlined ripple @click='dialog = false;')
                        v-icon mdi-window-close
                        | Close
                    v-btn.ma-2(color="red" outlined ripple :disabled="!(customerVehicle.customer_vehicle_id > 0)" @click='handleDestroyCustomerVehicle(); dialog = false;')
                        v-icon mdi-content-save
                        | Delete

</template>

<script lang="ts">
    import Vue from 'vue';

    // Helpers
    import { concatVehicleYearMakeModel } from "@/helpers/general";

    // Types
    import { VehicleYearMakeModelObj } from "@/helpers/general";

    export default Vue.extend({
        data() {
            return {
                dialog: false,
            }
        },
        methods: {
            handleDestroyCustomerVehicle() {

                // Return if not valid
                if (!(this.customerVehicle.customer_vehicle_id > 0)) {
                    return;
                }

                this.destroyCustomerVehicle(this.customerVehicle.customer_vehicle_id);
            },
        },
        computed: {
            vehicleYearMakeModel() {

                const vehObj = {
                    vehicleModelYear: this.customerVehicle.vehicle_model_year,
                    vehicleMake:      this.customerVehicle.vehicle_make,
                    vehicleModel:     this.customerVehicle.vehicle_model,
                }

                return concatVehicleYearMakeModel(vehObj as VehicleYearMakeModelObj);
            },
        },
        components: {
        },
        props: {
            customerVehicle:        Object,
            dark: Boolean,
            destroyCustomerVehicle: Function,
        },
        created() {
            return;
        },
    });
</script>

<style lang="scss" scoped>
</style>